import { z } from "zod";

/**
 * Admin AI conversations viewer (US-AE.F9 · @UC9099 dead-feature #5) — READ-ONLY, nguồn THẬT =
 * ai_audit_log group theo conversationId. Thay hội thoại fake ở /ai/chats.
 * rawPrompt redact theo vai (chỉ SUPER_ADMIN thô — mirror ai-audit). KHÔNG money tính client.
 *
 * LƯU Ý đặt tên: prefix `adminAiConversation*` để KHÔNG đụng contract AI end-user của E11
 * (`ai/index.ts` cũng export `aiConversation*` cho luồng chat người dùng — shape khác hẳn:
 * role/content/kind/proposal). Đây là contract của ADMIN VIEWER, tách bạch.
 */

/** 1 hội thoại (tóm tắt cho list). */
export const adminAiConversationSummarySchema = z.object({
  conversationId: z.string(),
  actorUserId: z.string().nullable(),
  /** intent gần nhất (label ngắn). */
  lastIntent: z.string(),
  /** outcome gần nhất. */
  lastOutcome: z.string(),
  /** số message (ai_audit_log row) trong hội thoại. */
  messageCount: z.number().int().nonnegative(),
  /** tier cao nhất chạm (T0/T1/T2) — null nếu không áp. */
  topTier: z.string().nullable(),
  lastAt: z.string(), // ISO8601 message gần nhất
});
export type AdminAiConversationSummary = z.infer<typeof adminAiConversationSummarySchema>;

export const adminAiConversationsListResponseSchema = z.object({
  data: z.array(adminAiConversationSummarySchema),
});
export type AdminAiConversationsListResponse = z.infer<
  typeof adminAiConversationsListResponseSchema
>;

/** 1 message trong hội thoại (từ ai_audit_log). rawPrompt null nếu vai không đủ. */
export const adminAiConversationMessageSchema = z.object({
  auditId: z.string(),
  at: z.string(),
  intent: z.string(),
  outcome: z.string(),
  tier: z.string().nullable(),
  /** câu chat thô — null cho vai KHÔNG đủ (chỉ SUPER_ADMIN thấy). */
  rawPrompt: z.string().nullable(),
  proposalKind: z.string().nullable(),
});
export type AdminAiConversationMessage = z.infer<typeof adminAiConversationMessageSchema>;

export const adminAiConversationDetailResponseSchema = z.object({
  conversationId: z.string(),
  actorUserId: z.string().nullable(),
  messages: z.array(adminAiConversationMessageSchema),
});
export type AdminAiConversationDetailResponse = z.infer<
  typeof adminAiConversationDetailResponseSchema
>;
